/**
 * SOLID Review
 * S — Strong. One combinator: the envelope every client decision returns.
 * O — Strong. A decision supplies its own changes and DTO schemas; this does not change.
 * L — N/A.
 * I — Strong. One function.
 * D — Good. zod only.
 */
import { z } from 'zod';

/**
 * `{ changes, dto }` — the backend's `DecisionOf` without `events` and `outbox`: the client publishes
 * nothing and owes nothing to a later process. `changes` is what the Application shell saves through
 * `ClientState.apply`; `dto` is what the shell answers its caller — for a PLAN decision, the request
 * the shell then sends to the server.
 */
export function DecisionOf<C extends z.ZodTypeAny, D extends z.ZodTypeAny>(changes: C, dto: D) {
  return z.object({ changes, dto });
}
